import React from 'react';
import { AddressSearchContainer } from '../styles';
import { reduxForm } from 'redux-form';
import { NewAddressSearch } from '@Components';

type AddressSearchFormProps = {
  retrievedValuesCallBack: (data: any) => any;
  searchPlaceHolder: string;
  isBeneAddressFlow?: boolean;
  onEnterManually?: () => void;
  countryCode?: string;
};
const AddressSearchForm: React.FC<AddressSearchFormProps> = ({
  retrievedValuesCallBack,
  searchPlaceHolder,
  isBeneAddressFlow,
  onEnterManually,
  countryCode
}: AddressSearchFormProps) => {
  const handleRetrievedValuesCallBack = (values: any) => retrievedValuesCallBack(values);
  return (
    //@ts-ignore
    <AddressSearchContainer>
      <NewAddressSearch
        newSearchUi={true}
        iconPlacement="left"
        boxInputSearchNewUi={true}
        retrievedValuesCallBack={handleRetrievedValuesCallBack}
        searchPlaceHolder={searchPlaceHolder}
        isNewBeneAddressFlow={isBeneAddressFlow}
        onEnterManually={onEnterManually}
        countryCode={countryCode}
      />
    </AddressSearchContainer>
  );
};

const AddressSearch = reduxForm<AddressSearchFormProps, any>({
  form: 'auAddressSearchForm'
})(AddressSearchForm);

export default AddressSearch;
